import React from 'react';
import './Blogs.css';

const Blogs = () => {
        return (
                <div className="mt-5 pt-5 blog">
                        <div className="container">
                                <h3 className="brand-color text-center fw-bold d-flex align-items-center justify-content-center"> Blog is </h3>
                                <div className="row"
                                        data-aos="zoom-in-up"
                                        data-aos-duration="3000">
                                        <div className="col-lg-5 mx-auto mt-4">
                                                <img src="https://cdn2.creativecirclemedia.com/walterborolive/original/20191218-154757-upcoming%20events%20logo.jpg" className="img-fluid rounded-3" alt="" />
                                        </div>
                                </div>
                        </div>
                </div>
        );
};

export default Blogs;